import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzInputModule } from 'ng-zorro-antd/input';

import { FormModule } from '@main-client/src/app/form/form.module';

import { SettingsInputPanelComponent } from '@main-client/src/app/settings/settings-input-panel/settings-input-panel.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    NzInputModule,
    ReactiveFormsModule,
  ],
  declarations: [SettingsInputPanelComponent],
  exports: [SettingsInputPanelComponent],
})
export class SettingsInputPanelModule {}
